<script>
export default {
  data() {
    return {};
  },
  methods: {
    redirectReloadProvider() {
      this.$router.push({ path: "/details/service-details" }).then(() => {
        this.$router.go();
      });
    },
  },
};
</script>
<template>
  <!-- Modal Succss -->
  <div class="modal fade service-models" id="successmodal">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body">
          <div class="text-center py-4">
            <span class="success-check mb-3 mx-auto"><i class="ti ti-check"></i></span>
            <h4 class="mb-2">Service Created Successfullly</h4>
            <p>
              “Electrical Services” has been Created, and updated on your Service List
            </p>
            <div class="f-flex align-items-center justify-content-center mt-3">
              <a
                href="javascript:void(0);"
                class="btn btn-light me-3"
                data-bs-dismiss="modal"
                >Close</a
              >
              <router-link
                to="/details/service-details"
                @click="redirectReloadProvider"
                class="btn btn-linear-primary"
                >Preview</router-link
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Modal Succss -->

  <div class="back-to-top">
    <a
      class="back-to-top-icon align-items-center justify-content-center d-flex"
      href="#top"
      ><i class="fa-solid fa-arrow-up"></i
    ></a>
  </div>
</template>
